export default __webpack_public_path__ + "static/media/qcontact_help_centre.c036f0df.png";